export function formatDateForDisplay(value: unknown, format = 'DD/MM/YYYY') {
  const text = String(value ?? '').trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text);
  if (!match) return text;
  const [, year, month, day] = match;
  return format === 'MM/DD/YYYY' ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
}

export function maskDateInput(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, 8);
  const first = digits.slice(0, 2);
  const second = digits.slice(2, 4);
  const year = digits.slice(4);
  const separator = '/';
  if (digits.length <= 2) return first;
  if (digits.length <= 4) return `${first}${separator}${second}`;
  return `${first}${separator}${second}${separator}${year}`;
}

export function dateDisplayToStorage(value: string, format = 'DD/MM/YYYY') {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!match) return value;
  const [, first, second, year] = match;
  const month = format === 'MM/DD/YYYY' ? first : second;
  const day = format === 'MM/DD/YYYY' ? second : first;
  return `${year}-${month}-${day}`;
}

export function isStrictPastIsoDate(value: string, now = new Date()) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const [, yearText, monthText, dayText] = match;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return false;
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return date.getTime() < today;
}
